<template>
  <div class="flex flex-col gap-3.5">
    <!-- Zona de subida (drag & drop) o previsualización de la imagen elegida -->
    <div class="grid place-items-center p-2.5 rounded-lg bg-gray-50">
      <b-field v-if="!imagePreview" class="w-full mb-0">
        <b-upload v-model="dropFileTemp" drag-drop expanded accept="image/*" @input="onImageSelected">
          <div class="flex flex-col items-center gap-1.5 py-4 px-3 text-sm text-gray-500">
            <b-icon icon="upload" size="is-medium" pack="fas"></b-icon>
            <p>{{ $t('drag_file_or_click_select') }}</p>
          </div>
        </b-upload>
      </b-field>

      <div v-else class="relative inline-block">
        <img :src="imagePreview" alt="preview" class="block rounded-lg" style="max-width: 320px; max-height: 240px;" />
        <button class="delete is-small absolute top-2 right-2" type="button" @click="deleteDropFile"></button>
      </div>
    </div>

    <!-- Título de la imagen -->
    <b-field :label="$t('title')">
      <b-input v-model="name" icon-pack="fas" icon="heading" :placeholder="$t('name_image')"></b-input>
    </b-field>

    <!-- Pie de foto (ocultable por prop para reutilizar el formulario sin él) -->
    <b-field v-if="showCaption" :label="$t('caption')">
      <b-input v-model="caption" type="textarea" rows="2"
        :placeholder="$t('image_description')"></b-input>
    </b-field>

    <!-- Acciones -->
    <div class="flex justify-end gap-2">
      <b-button size="is-small" @click="$emit('cancel')">{{ $t('cancel') }}</b-button>
      <b-button size="is-small" type="is-primary" :loading="isLoading" :disabled="!dropFileTemp" @click="submit">
        <b-icon pack="fas" icon="upload"></b-icon>
        <span>{{ $t('upload_image') }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
// Formulario de subida de imagen (solo presentación). La compresión vive en el helper.
// Emite `submit` con { name, details, image(File) } y `cancel` para cerrar.
import { resizeAndCompressImage } from '../helpers/detailed-report.helper.js'

export default {
  name: 'report-image-upload-form',

  props: {
    // Muestra el input "Pie de foto". Oculto → el formulario solo pide título (como el legacy).
    showCaption: { type: Boolean, default: true },
    // Gantt sube a mayor resolución/calidad.
    isGantt: { type: Boolean, default: false },
  },

  data() {
    return {
      dropFileTemp: null,
      imagePreview: null,
      name: null,
      caption: '',
      isLoading: false,
    }
  },

  methods: {
    onImageSelected(file) {
      if (!file) { this.imagePreview = null; return }
      const reader = new FileReader()
      reader.onload = (e) => { this.imagePreview = e.target.result }
      reader.readAsDataURL(file)
      if (!this.name) this.name = file.name
    },

    deleteDropFile() {
      this.dropFileTemp = null
      this.imagePreview = null
    },

    async submit() {
      if (!this.dropFileTemp) { this.$notify.error('error_uploading_image'); return }
      this.isLoading = true
      try {
        if (!this.name) this.name = this.dropFileTemp.name
        const maxSize = this.isGantt ? 2000 : 600
        const quality = this.isGantt ? 0.9 : 0.8
        const image = await resizeAndCompressImage(this.dropFileTemp, maxSize, quality)
        this.$emit('submit', { name: this.name, details: this.showCaption ? (this.caption || '') : '', image })
      } finally {
        this.isLoading = false
      }
    },

    // Deja el formulario listo para una nueva subida (lo invoca el modal al abrir/cerrar).
    reset() {
      this.dropFileTemp = null
      this.imagePreview = null
      this.name = null
      this.caption = ''
      this.isLoading = false
    },
  },
}
</script>
